/** The sentence a tab opens with, then what explains it, then optional actions. */
export default function Answer({ answer, loading, children }) {
  if (!answer) {
    return loading ? <section className="sa-answer is-loading" aria-busy="true"><h2>Working it out…</h2></section> : null;
  }
  return <section className="sa-answer" aria-label="In short">
    <h2>{answer.title}</h2>
    {answer.detail && <p>{answer.detail}</p>}
    {children && <div className="sa-answer-actions">{children}</div>}
  </section>;
}
